import { render, staticRenderFns } from "./ludimos-smart-lane.vue?vue&type=template&id=ecc4f336&scoped=true&"
var script = {}
import style0 from "./ludimos-smart-lane.vue?vue&type=style&index=0&id=ecc4f336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc4f336",
  null
  
)

export default component.exports